import { useState } from 'react';
import * as AWS from 'aws-sdk';
import { configData } from '../config/systemconfigurationconstants';
import { useEncryption } from '../customHooks/useEncryption';
const UseLambdaInvocations = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    const invokeLambda = async (command, additionalData) => {
        setLoading(true);
        setError(null);

        const data = {
            Command: command,
            ...additionalData,
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data),
        };

        try {
            const response = await lambda.invoke(params).promise();
            const lambdaResponse = JSON.parse(response.Payload.toString());
            const parsedBody = JSON.parse(lambdaResponse.body);
            // Handle both possible formats for `Output`
            let parsedResponse;
            try {
                // Check if Output is a string and needs to be parsed
                parsedResponse = typeof parsedBody.Output === 'string'
                    ? JSON.parse(parsedBody.Output)
                    : parsedBody.Output;
            } catch (error) {
                console.error("Failed to parse Output:", error);
                parsedResponse = null; // or handle error accordingly
            }

            return parsedResponse;
        } catch (err) {
            console.error(err);
            setError('Failed to invoke lambda function');
            throw err; // Rethrow the error for further handling if needed
        } finally {
            setLoading(false);
        }
    };

    return { invokeLambda, loading, error };

};
export default UseLambdaInvocations
